
angular.module('bmsApp.settings')
	.factory('SMCleaningServiceSvc', [
		'$rootScope',
		'$http',
		'$log',
		'$window',
		'$q',
		'CRUDSvc',
		'$modal',
		'TaxHelperSvc',
		function ($rootScope, $http, $log, $window, $q, CRUDSvc, $modal, TaxHelperSvc) {

	function calcDiscountedNet (jobCleaningService) {
		if (angular.isUndefined(jobCleaningService.net) || angular.isUndefined(jobCleaningService.vat)) {
			return undefined;
		}

		return TaxHelperSvc.netFromGross(calcDiscountedGross(jobCleaningService));
	}

	function calcDiscountedVat (jobCleaningService) {
		if (angular.isUndefined(jobCleaningService.net) || angular.isUndefined(jobCleaningService.vat)) {
			return undefined;
		}

		return TaxHelperSvc.vatFromGross(calcDiscountedGross(jobCleaningService));
	}

	function calcDiscountedGross(jobCleaningService) {
		if (angular.isUndefined(jobCleaningService.gross)) {
			return undefined;
		}
		var discountedGross = parseFloat(jobCleaningService.gross);
		if (angular.isObject(jobCleaningService.discount_type)) {
			var discountType = jobCleaningService.discount_type;
			if (discountType.value === 'percent') {
				discountedGross -= discountedGross * (parseFloat(jobCleaningService.discount_value) || 0) / 100;
			}
			if (discountType.value === 'flat') {
				discountedGross -= parseFloat(jobCleaningService.discount_value) || 0;
			}
		}

		return discountedGross;
	}

	return {
		index: function (params) {
			return CRUDSvc.get('api/sm/cleaningServices/index', params);
		},
		save: function (params) {
			return CRUDSvc.post('api/sm/cleaningServices/save', params);
		},
		options: function (data) {
			return CRUDSvc.get('api/sm/cleaningServices/options', data);
		},
		showCleaningServiceModal: function(cleaningService, licenseId) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/sm/quote/templates/CleaningServiceSaveModal.html',
				controller: 'SMCleaningServiceSaveModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					licenseId: () => {
						return licenseId;
					},
					cleaningService: () => {
						return angular.copy(cleaningService);
					},
				}
			});

			return modalInstance.result;
		},
		showOnlineCleaningPricingModal: function(licenseId) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/settings/SMCleaningServices/templates/OnlineCleaningPricingModal.html',
				controller: 'OnlineCleaningPricingModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					licenseId: licenseId,
				}
			});

			return modalInstance.result;
		},
		discountType: {
			options: function (params) {
				return CRUDSvc.get('api/sm/cleaning-service-discount-type/options', params);
			}
		},
		calcDiscountedNet: calcDiscountedNet,
		calcDiscountedVat: calcDiscountedVat,
		calcDiscountedGross: calcDiscountedGross,
		showMaterialTestPhotosModal: function(jobCleaningService, visit) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/sm/job/templates/MaterialTestPhotosModal.html',
				controller: 'MaterialTestPhotosModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					jobCleaningService: () => {
						return jobCleaningService;
					},
					visit: () => {
						return visit;
					},
				}
			});

			return modalInstance.result;
		},
		showRugCleaningPhotosModal: function(jobCleaningService, visit) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/sm/job/templates/RugCleaningPhotosModal.html',
				controller: 'RugCleaningPhotosModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					jobCleaningService: () => {
						return jobCleaningService;
					},
					visit: () => {
						return visit;
					},
				}
			});

			return modalInstance.result;
		},
	}
}]);




